import React from 'react';
import { ModuleBridge } from '../components';

export const Admin = () => {
    return <ModuleBridge moduleId="admin_orgs_module" />;
};
